import { render } from "./OneProductAboutComponent.vue?vue&type=template&id=315d1880&scoped=true"
import script from "./OneProductAboutComponent.vue?vue&type=script&lang=js"
export * from "./OneProductAboutComponent.vue?vue&type=script&lang=js"

import "./OneProductAboutComponent.vue?vue&type=style&index=0&id=315d1880&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315d1880"]])

export default __exports__